import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    marginTop: 40,
    gridTemplateColumns: '173px repeat(6,1fr)',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '133px',
      gridTemplateColumns: '1fr'
    }
    // background: 'red'
  },

  titleRestrictions: {
    height: 50,
    textAlign: 'center',
    fontWeight: 700,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  valueContainer: {
    height: 50,
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  restrictionSelector: {
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[100]}`
  },
  restrictionSelectorTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
    // '& p': {
    //   color: theme.palette.primary.main
    // }
  },
  ratePlaneTextAddons: {
    fontSize: '14px',
    fontWeight: 800,
    color: theme.palette.primary.main
  },
  infoIcon: {
    borderRadius: '10px',
    background: theme.palette.grey[500],
    '&.MuiSvgIcon-root': {
      color: theme.palette.background.default,
      fontSize: '20px'
    }
  },
  tooltip: {
    '&.MuiTooltip-tooltip': {
      background: theme.palette.grey[600]
    }
  },
  tooltipTitle: {
    fontSize: 14,
    color: theme.palette.background.default,
    textAlign: 'left'
  },
  inventoryInputItemContainer: {
    marginBottom: 20
  },
  removalWarning: {
    gridColumn: '1 / -1',
    marginTop: 8
  }
}))

export default useStyles
